// extracted by mini-css-extract-plugin
export var image = "PartnerCard-module--image--83269";
export var imageEffect = "PartnerCard-module--imageEffect--4fffc";
export var imageWrapper = "PartnerCard-module--imageWrapper--e4267";
export var root = "PartnerCard-module--root--e9128";